import Input from "./input";
import Date from "./date";

const BaseInputComponents = {
  text: Input,
  date: Date,
};

export default BaseInputComponents;
